<template>
    <div id="file-upload-sinester-component">
        <div id="mainContent">

            <form id="formImport" class="formImport">
                <div class="row justify-content-center scr-gap-15-0">
                    <div class="col-12 col-md-3">
                        <!--                        <select name="company_id" v-model="company.company_id" id="">
                            <option :value="0">Empresa de Siniestro</option>
                            <option :value="2">Salud Digna</option>
                            <option :value="3">Hosp. San Jose</option>
                            <option :value="4">QFB Sarc</option>
                            <option :value="1">Lab. Maria Isabel</option>
                          <option :value="5">Google Drive</option>
                        </select>-->
                        <select data-select="on" v-model="prov_role_id" name="provider_id" id="provider_id"
                            v-on:change="handleChangeProvider($event)" class="required">
                            <option :value="0">Tipo de Proveedor*</option>
                            <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                                {{ prov.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="company.company_id" name="company_id" id="company_id"
                            class="required">
                            <option :value="0">Proveedores*</option>
                            <option v-for="lprov in list_providers" :value="lprov.id" :key="lprov.id">
                                {{ lprov.genericName }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Archivo de siniestro <br> <i class="fas fa-upload"></i>
                                <input type="file" data-label="avatar" name="xlsFile" v-on:change="getFile"
                                    placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info file"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">
                            Cargar
                        </button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>

<script>
import { myMixins } from "../mixins/myMixins";
import { importsinesterfileService } from "../../Services/ImportSinesterFile.service";
import { rolesService } from "../../Services/Roles.service";
import { getFormData } from "../../Utils/getDataForm";


export default {
    name: "load-sinester-file",
    mixins: [myMixins],
    data() {
        return {
            list_providers: [],
            prov_role_id: 0,
            prov_id: 0,
            roles: [],
            providers: [],
            company: {
                company_id: 0,
            },
        }
    },
    methods: {
        async selectProvider() {
            this.providers = await rolesService.getProvidersForSinester();
            //console.log('providers', this.providers);
        },

        handleChangeProvider(e) {
            this.selectCompanyByRoleProvider(e);
        },

        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formImport');
            const formData = getFormData('formImport');
            if (respVal) {
                this.disableSubmitBtn(true);
                resp = await importsinesterfileService.saveOne(formData, { isForm: true });
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
            this.getAlert(resp.process);
        },

        async index() {
            await this.selectProvider();
            this.roles = await rolesService.getProvidersForSinester();
        },

        getFile(event) {
            this.getNameFile(event, 'file');
        },

    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
.fotoUploader {
    margin-top: 0
}
</style>
